import { HttpGateway } from '@mojility/coach-core'

export default class AnalysisGateway extends HttpGateway {

  constructor(coachHttpClientFactory) {
    super(coachHttpClientFactory);
  }

  questionnairesSentToWorkspace(secretKey, workspaceId) {
    return this.authenticatedGet(secretKey, `analysis/workspace/${workspaceId}/questionnaire`);
  }

  versionsSentToWorkspace(secretKey, workspaceId, questionnaireId) {
    let path = `analysis/workspace/${workspaceId}/questionnaire/${questionnaireId}/versions`;
    return this.authenticatedGet(secretKey, path);
  }

  sectionsSentToWorkspace(secretKey, workspaceId, questionnaireId, versionId) {
    let path = `analysis/workspace/${workspaceId}/questionnaire/${questionnaireId}/versions/${versionId}/sections`;
    return this.authenticatedGet(secretKey, path);
  }

  questionsSentToWorkspace(secretKey, workspaceId, questionnaireId, versionId, sectionId) {
    let path = `analysis/workspace/${workspaceId}/questionnaire/${questionnaireId}/versions/${versionId}/sections/${sectionId}/questions`;
    return this.authenticatedGet(secretKey, path);
  }

}